import { logger } from "@/utils/logger";

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css' // This now imports all our modular CSS files
import { Toaster } from './components/ui/toaster.tsx'
import { Toaster as SonnerToaster } from './components/ui/sonner.tsx'
import { initializeIOSPwaAuth } from './utils/auth/iOSPwaAuthInit.ts'
import { isIOSDevice, isPwaMode } from './utils/pwaUtils.ts'
import IOSPwaHelper from './components/debug/IOSPwaHelper.tsx'

// Initialize iOS PWA auth recovery as early as possible
if (typeof window !== 'undefined') {
  // Run asynchronously to not block rendering
  setTimeout(() => {
    initializeIOSPwaAuth().then(success => {
      if (success) {
        logger.info("iOS PWA auth initialization successful");
      }
    });
  }, 0);
  
  // Just add a marker class for iOS PWA mode for styling purposes
  // Important: Don't set any manual viewport offsets that conflict with Safari's viewport
  if (isIOSDevice() && isPwaMode()) {
    try {
      logger.info("Marking iOS PWA mode for styling purposes");
      document.documentElement.classList.add('ios-pwa');
      
      // Force viewport calculation
      
    } catch (e) {
      logger.error("Failed to initialize iOS PWA mode:", e);
    }
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <IOSPwaHelper />
    <Toaster />
    <SonnerToaster position="bottom-right" closeButton />
  </React.StrictMode>,
)
